export default {
	updateApiBaseUrl: 'update-api-base-url',
	updateActionHint: 'update-action-hint'
};